var map = {
	"./button_1.png": 5508,
	"./button_2.png": 5423,
	"./button_3.png": 7334,
	"./button_4.png": 1593,
	"./button_5.png": 6768,
	"./button_6.png": 5451,
	"./button_7.png": 6450,
	"./button_8.png": 8453,
	"./button_9.png": 5564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6440;